import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-floating-whatsapp',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-whatsapp.html',
  styleUrl: './floating-whatsapp.scss'
})
export class FloatingWhatsappComponent implements OnInit {
  isVisible = false;
  isExiting = false;
  whatsappUrl = '';
  private exitTimeout: any;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    // Set appropriate WhatsApp URL based on device
    this.setWhatsAppUrl();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const shouldBeVisible = window.pageYOffset > 300;
    
    if (shouldBeVisible && !this.isVisible && !this.isExiting) {
      // Button is becoming visible
      this.isVisible = true;
      this.isExiting = false;
    } else if (!shouldBeVisible && this.isVisible && !this.isExiting) {
      // Button is becoming hidden - start exit animation
      this.isExiting = true;
      this.exitTimeout = setTimeout(() => {
        this.isVisible = false;
        this.isExiting = false;
      }, 400); // Match animation duration
    }
  }

  private setWhatsAppUrl(): void {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      // For mobile devices, use wa.me URL to open WhatsApp app
      this.whatsappUrl = 'https://wa.me/919890446677';
    } else {
      // For desktop, use WhatsApp Web
      this.whatsappUrl = 'https://web.whatsapp.com/send?phone=919890446677';
    }
  }

  ngOnDestroy(): void {
    if (this.exitTimeout) {
      clearTimeout(this.exitTimeout);
    }
  }

  t(key: string): string {
    return this.languageService.t(key);
  }
}


